<!--所有班级的最后一个任务，可以方便发送任务-->
<template>
  <or-layout>
    <a-form layout="inline">
      <a-form-item>
        <a-select v-model="searchFrom.type_id" placeholder="任务类型" style="width: 200px;" allowClear>
          <a-select-option v-for="(item) in missionTypeList" :key="item.id" :value="item.id">{{ item.name
          }}</a-select-option>
        </a-select>
      </a-form-item>


      <a-form-item>
        <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
          <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 140px;" allow-clear>
          <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-select v-model="searchFrom.missiontime" placeholder="任务状态" allow-clear style="width: 120px;">
          <a-select-option :key="0" :value="0">全部</a-select-option>
          <a-select-option :key="1" :value="1">已结束</a-select-option>
          <a-select-option :key="2" :value="2">未开始</a-select-option>
          <a-select-option :key="3" :value="3">进行中</a-select-option>
        </a-select>
      </a-form-item>

    <!--a-form-item>
                 <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                     <a-select-option :key="0" :value="0">未开班</a-select-option>
                     <a-select-option :key="1" :value="1">已开班</a-select-option>
                     <a-select-option :key="2" :value="2">已结班</a-select-option>
                 </a-select>
             </a-form-item>
             
             <a-form-item>
                 <a-select v-model="searchFrom.status" placeholder="班级状态" allow-clear style="width: 120px;">
                     <a-select-option :key="0" :value="0">禁用</a-select-option>
                     <a-select-option :key="1" :value="1">可用</a-select-option>
                 </a-select>
             </a-form-item>
             
             <a-form-item>
                 <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 80px;">
                       <a-select-option :key="-1" value="">全部</a-select-option>
                     <a-select-option :key="0" value="寒假">寒假</a-select-option>
                     <a-select-option :key="1" value="春季" >春季</a-select-option>
                     <a-select-option :key="2" value="暑假">暑假</a-select-option>
                     <a-select-option :key="3" value="秋季">秋季</a-select-option>
                 </a-select>
             </a-form-item>
             <a-form-item>
                 <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 90px;">
                      <a-select-option :key="-1" value="">全部</a-select-option>
                      <a-select-option :key="2" value="2022">2022年</a-select-option>
                     <a-select-option :key="0" value="2021">2021年</a-select-option>
                        <a-select-option :key="1" value="2020">2020年</a-select-option>
                 </a-select>
                 </a-form-item-->
    <!-- <a-form-item>
                 <a-select v-model="searchFrom.user_type" placeholder="老师/班主任" allow-clear style="width: 120px;">
                     <a-select-option :key="0" :value="0">老师</a-select-option>
                     <a-select-option :key="1" :value="1">班主任</a-select-option>
                 </a-select>
             </a-form-item> >
             <a-form-item>
                 <a-select v-model="searchFrom.type" placeholder="班型" allow-clear style="width: 120px;">
                     <a-select-option :key="0" :value="0">培优</a-select-option>
                     <a-select-option :key="1" :value="1">提高</a-select-option>
                     <a-select-option :key="2" :value="2">英才</a-select-option>
                     <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                 <a-select-option :key="4" :value="4">30元班</a-select-option>
                 </a-select>
                 </a-form-item-->
      <a-form-item>
        <a-input placeholder="任务名字" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
      </a-form-item>
    </a-form>

    <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" @change="onPaginationChange" bordered>
      <a-table-column key="campus_name" title="校区" data-index="campus_name" />
      <a-table-column key="grade_name" title="年级" data-index="grade_name" />
      <a-table-column key="squadname" title="班级名字" data-index="squadname" />
      <a-table-column key="missiontypename" title="任务类型">
        <template slot-scope="item">
          {{ item.missioninfo.missiontypename }}
        </template>
      </a-table-column>

      <a-table-column key="missiontypename" title="任务名称">
        <template slot-scope="item">
          {{ item.missioninfo.missionname }}
        </template>
      </a-table-column>

      <a-table-column key="create_time" title="开始时间">
        <template slot-scope="item">
          {{ moment(item.missioninfo.start_time * 1000).format('lll') }}
        </template>
      </a-table-column>
      <a-table-column key="end_time" title="结束时间">
        <template slot-scope="item">
          {{ moment(item.missioninfo.end_time * 1000).format('lll') }}
        </template>
      </a-table-column>


    </a-table>
  </or-layout>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      data: [],
      campusList: [],
      gradeList: [],
      pageinfo: { total: 1, current: 1, pageSize: 999 },
      missionTypeList: [],
      searchFrom: {
        type_id: undefined,
        testpaper_type: undefined,
        grade_id: undefined,
        campus_id: undefined,
      },

    }
  },
  mounted() {
    this.getMissionTypeList();
    this.getGradeList();
    this.getCampusList();
  },

  methods: {
    getCampusList() {
      this.$axios
        .post("/api/admin/getmycampuslist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data;
            this.tableSearch();
            //  this.getCourseList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getMissionTypeList() {
      this.$axios
        .post("/api/BasicMissionType/index")
        .then((res) => {
          if (res.code == 200) {
            this.missionTypeList = res.data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getGradeList() {
      this.$axios
        .post("/api/BasicGrade/index")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.gradeList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    tableSearch() {
      this.getTableList(this.searchFrom);
    },
    getTableList(data) {
      this.$axios
        .post("/api/BasicMission/getsquadendmission", {
          data,
          pageinfo: this.pageinfo,
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getTableList(this.searchFrom);
    },

    searchGrade() {
      this.pageinfo.current = 1;
      this.getCampusSquadList();
    },
    changeTimeRange(val) {
      this.from.start_time = parseInt(val[0].valueOf() / 1000);
      this.from.end_time = parseInt(val[1].valueOf() / 1000);
    },
    getCampusInfo() {
      this.$axios
        .post("/api/OrgCampus/getinfo", {
          data: { campus_id: this.campus_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusInfo = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    getNianjiList() {
      this.$axios
        .post("/api/BasicGrade/index", {
          pageinfo: {
            pageSize: 999
          }
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.nianjiList = res.data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    tabsChange(key) {
      this.pageinfo.current = 1;
      switch (key) {
        case "grade":
          this.getCampusSquadList();
          break;
        case "teacher":
          this.getTeacherList()
          break;
        default:
          break;
      }
    },

    tableEdit(item) {
      this.squadVisible = true;
      item = JSON.parse(JSON.stringify(item));
      this.getCampusTeacherList();
      this.form = item;
      this.squadVisible = true;
    },
    getCampusTeacherList() {
      this.$axios
        .post("/api/OrgCampus/getteacher", { data: { org_id_by_campus_id: this.campus_id }, pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.teacherList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCourseList() {
      this.$axios
        .post("/api/BasicCourse/index", { data: { status: 1 }, pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.courseList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampusSquadList() {
      this.loading = true;
      this.$axios
        .post("/api/OrgSquad/getcampussquad", {
          data: this.gradeSearchForm,
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusGradeList = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    changeSquadStatus(data) {
      this.$axios
        .post("/api/OrgSquad/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getCampusSquadList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    changeTeacherStatus(data) {
      this.$axios
        .post("/api/Admin/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTeacherList()
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTeacherList() {
      this.loading = true;
      this.$axios
        .post("/api/OrgCampus/getteacher", {
          pageinfo: this.pageinfo,
          data: { org_id_by_campus_id: this.campus_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.teacherList = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    },

    onTeacherPaginationChange(item) {
      this.getTeacherList();
      this.pageinfo.current = item.current;
    },
    goPage() {
      this.$router.push('/orgcampus');
    },
    addSquad() {
      this.squadVisible = true;
      this.form.id = undefined;
    },
    addteacher() {
      this.teacheraddvisible = true;
    },
    modalCancel() {
      this.squadVisible = false;
      if (this.form.id != undefined) {
        this.form = {
          name: undefined,
          campus_id: undefined,
          course_id: undefined,
          grade_id: undefined,
          admin_id: undefined,
          instructor: undefined,
          amount: undefined,
          opening: undefined
        }
      }
    },
    teachermodalCancel() {
      this.teacheraddvisible = false;
    },
    squadModalSave() {
      let _this = this;
      if (!this.form.course_id) {
        _this.$error({
          title: "错误",
          content: "必须选择所属课程",
          okText: "确定"
        });
        return false;
      }
      let url = "/api/OrgSquad/edit";
      if (!this.form.id) {
        url = "/api/OrgSquad/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            _this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            _this.getCampusSquadList();
            _this.squadVisible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    moment
  }
};


</script>

<style></style>
